"use client";
import "./style.scss";

import React, { ElementType, FunctionComponent } from "react";

import classNames from "classnames";
import { Container, Typography } from "components/ct-design";
import { TypographyProps } from "ct-design/dist/lib/Typography/type";
interface Props {
  showIcon: boolean;
  icon?: ElementType;
  title: string;
  selected: boolean | (() => boolean);
  wrapperClass?: string;
  onClick: () => void;
  description?: string;
  disabled?: boolean;
  titleClass?: string;
  iconRight?: ElementType;
  iconRightAnimation?: string;
  titleVariant?: TypographyProps["variant"];
}

const Pill: FunctionComponent<Props> = (props) => {
  const {
    showIcon = false,
    icon: Icon,
    title = "",
    selected,
    wrapperClass = "",
    onClick,
    description,
    disabled,
    // titleClass,
    iconRight: IconRight,
    iconRightAnimation,
    titleVariant = "P2",
  } = props;

  const pillWrapperclasse = classNames(
    "d-inline-block px-2",
    wrapperClass,
    selected ? "selected bg-primary bc-neutral-900" : "bc-line-500 ba-solid",
    disabled && "disabled"
  );

  const titleDescriptionWrapper = classNames(
    "flex flex-column",
    description ? "my-2" : "my-6px",
    {
      // "mr-2": IconRight,
      // "mr-3": !IconRight,
      // "ml-2": Icon,
      // "ml-3": !Icon,
    }
  );

  return (
    <Container
      className={pillWrapperclasse}
      onClick={() => onClick()}
      data-testid="pill-wrapper"
      css={{
        display: "inline-block",
        paddingTop: "6px",
        paddingBottom: "6px",
        borderRadius: "30px",
      }}
      backgroundColor={disabled ? "#F3F3F3" : ""}
    >
      <div className="flex flex-middle">
        <div className={titleDescriptionWrapper}>
          <Typography
            variant={titleVariant}
            className="flex flex-middle mr-1 c-pointer"
            data-testid="pill-title"
            color={disabled ? "disabled" : undefined}
          >
            {showIcon && Icon && (
              // <Icon />
              <Icon
                className={` ${selected ? "activeSVG" : "fill-black"} mr-2  `}
                data-testid="pill-icon"
              />
            )}
            {title}
          </Typography>
          {description && (
            <p
              className={`fw-500 fs-2 c-neutral-600 ${selected && "activeCT"}`}
              data-testid="pill-description"
            >
              {description}
            </p>
          )}
        </div>
        {showIcon && IconRight && (
          <IconRight
            className={` ${
              selected ? "activeSVG" : "fill-black"
            } mr-2 my-2 ${iconRightAnimation}`}
            data-testid="pill-icon"
          />
        )}
      </div>
    </Container>
  );
};

export default Pill;
